module.exports = __webpack_public_path__ + "img/heia_thumb.8621f660.gif";